import React, { Component } from 'react';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { } from 'react-router';
import dateService from '../../common/services/dateService'
import { getCommentListCourse, clearComment } from '../../mylibrary/actions/commentActions'
import CommentBody from '../../mylibrary/types/CommentBody'
import { UserData } from '../../mylibrary/types/ContentData';
import { List } from '@material-ui/core';
import ContentEditable from "react-contenteditable";
import commentService from '../../mylibrary/services/commentService';
import courseCommentService from '../services/commentService'
import {styles} from '../styling/component/CourseCommentDialog'

import {
	Theme,
	createStyles,
	withStyles,
	WithStyles,
	Card,
	CardContent,
	Grid,
	Typography,
	MenuItem,
	Button,
	Avatar,
	Menu,
	ListItemText,
	ListItem,
	ListItemAvatar,
	Divider,
} from '@material-ui/core';
import {
	CloseOutlined as CloseIcon,
	KeyboardArrowDown as MoreIcon,
} from '@material-ui/icons'
import {
	MyPATDialog,
	MyPATTextField,
	MyPATTextArea,
	MyPATSelect,
	MyPATIconButton,
	MyPATExpansionPanel,
} from '../../common';

interface CommentDialogProps extends WithStyles<typeof styles> {
	isDialogOpen: boolean,
	dialogCloseHandler: () => void,
	getCommentListCourse: (courseId: string, status: string, limit: number, skip: number) => void,
	history: any,
	usersList: UserData[],
	comments: CommentBody[],
	content: any,
	userDetail: any
	clearComment: () => void,
	courseID:string
}

type mentionsBody = {
	sourceId: String,
	sourceType: String,
	userId: String,
	text: String,
	from: Number,
	to: Number
}


let currentCaret = 0;

interface CommentDialogState {
	activeNav: string | "open" | "close" | "all",
	isAddCommentDialogOpen: boolean,
	isShowReplyComment: any,
	formData: {
		packageId: string,
		comment: string,
		contentId: string,
		mentions: any[],
		userId: "",
		_id: ""
	},
	moreMenuAnchor: any,
	openMenu: string,
	searchedUser: UserData[],
	showSuggestedUsers: boolean,
	isAtPresent: boolean,
	isEdit: boolean,
	isPageAvailabe: boolean,
	pageSkip: number,
	limit: number,
	// currentCaret: number,
}

class CourseCommentDialog extends Component<CommentDialogProps, CommentDialogState> {
	el: any;
	constructor(props: CommentDialogProps) {
		super(props);
		this.state = {
			activeNav: "open",
			isAddCommentDialogOpen: false,
			isShowReplyComment: {
				isShow: false,
				commentId: '',
			},
			formData: {
				packageId: '',
				contentId: '',
				comment: '',
				mentions: [],
				userId: '',
				_id: ''
			},
			searchedUser: [],
			moreMenuAnchor: null,
			openMenu: '',
			showSuggestedUsers: false,
			isAtPresent: false,
			isEdit: false,
			isPageAvailabe: false,
			pageSkip: 0,
			limit: 20,
		};

		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleAddCommentDialogSave = this.handleAddCommentDialogSave.bind(this);
		this.handleReplyCommentToggle = this.handleReplyCommentToggle.bind(this);
		this.openAddCommentDialogue = this.openAddCommentDialogue.bind(this);
		this.isAtPresent = this.isAtPresent.bind(this);
		this.preventEnter = this.preventEnter.bind(this);
		this.handleAddCommentClose = this.handleAddCommentClose.bind(this);
		this.handleCloseCommentBox = this.handleCloseCommentBox.bind(this);
		this.handleEditCommentDialog = this.handleEditCommentDialog.bind(this);
		this.listenToScroll = this.listenToScroll.bind(this);
		this.handleChangeStatus = this.handleChangeStatus.bind(this);
		currentCaret = 0;
	}

	handleNavigationClick = (activeNav: string) => {
		const { getCommentListCourse, clearComment ,courseID} = this.props;
		const { limit } = this.state;
		clearComment();
		getCommentListCourse(courseID, activeNav, limit, 0);
		this.setState({ activeNav, pageSkip: 0 });
	};

	resetForm = () => {
		let { formData, isAtPresent, searchedUser, showSuggestedUsers } = this.state;
		formData["comment"] = "";
		formData["mentions"] = [];
		currentCaret = 0;
		isAtPresent = false;
		searchedUser = [];
		showSuggestedUsers = false;
		this.setState({ formData, isAtPresent, searchedUser, showSuggestedUsers });
	}

	componentDidMount() {
		const { getCommentListCourse, clearComment,courseID } = this.props;
		const { limit } = this.state;
		clearComment();
		
		getCommentListCourse(courseID, 'Open', limit, 0);
	}

	componentDidUpdate(prevProps: any) {
		const { isPageAvailabe } = this.state;
		if (!isPageAvailabe) {
			this.el.scrollTop = this.el.scrollHeight - 400;
		}
	}

	handleInputChange = (evt: any) => {
		let { value, name } = evt.target;
		let { formData }: any = this.state;
		formData[name] = value;
		this.setState({ formData });
	}


	handleEditCommentDialog = () => {
		let { formData, limit } = this.state;
		const {clearComment, getCommentListCourse,courseID } = this.props;

		var parameter = {
			"__v": 0,
			"packageId": courseID,
			"comment": formData.comment,
			"userId": formData.userId,
			"_id": formData["_id"],
			"updatedAt": new Date().toISOString(),
			"createdAt": new Date().toISOString(),
			"commentStatus": "Open"
		}
		commentService.editComment(parameter)
			.then((res: any) => {

				this.handleAddCommentClose();
				clearComment();
				getCommentListCourse(courseID, 'OPEN', limit, 0);
				this.setState({ pageSkip: 0 });
			})
	}

	handleAddCommentDialogSave = () => {
		let { formData, limit } = this.state;
		let {courseID} = this.props
		var parameter = {
			"packageId": courseID,
			"comment": formData.comment,
		}
		let textComment = parameter.comment.replace(/&nbsp;/g, '');
		if (textComment.trim().length == 0) {
			return false;
		}
		courseCommentService.addComment(parameter)
			.then((res: any) => {
				this.handleAddCommentClose();
				clearComment();
				// getCommentListCourse(courseID, 'OPEN', limit, 0);
				this.props.getCommentListCourse(courseID, 'Open', limit, 0);
				this.setState({ pageSkip: 0 });
			})

	}
	handleAddCommentClose = () => {
		this.resetForm();
		this.setState({ isAddCommentDialogOpen: false })
	}
	handleReplyCommentToggle = (e: any, commentId: string) => {
		// e.stopPropagation()
		let { isShowReplyComment } = this.state;
		isShowReplyComment.isShow = isShowReplyComment.commentId == commentId ?
			!isShowReplyComment.isShow : true;
		isShowReplyComment.commentId = commentId;
		this.setState({ isShowReplyComment })
	}


	handleMoreMenuOpen = (e: any, target: string) => {
		e.stopPropagation();
		return this.setState({ moreMenuAnchor: e.currentTarget, openMenu: target });
	};

	handleMoreMenuClose = (e: any) => {
		e.stopPropagation();
		return this.setState({ moreMenuAnchor: null, openMenu: '' })
	};

	handleDeleteCommentMenuClick = (e: any, commentId: string) => {
		e.stopPropagation();
		let { limit } = this.state;
		let {courseID} = this.props;
		commentService.deleteComment(commentId)
			.then((res: any) => {
				if (res) {
					this.props.clearComment();
					
					this.props.getCommentListCourse(courseID, 'Open', limit, 0);
				}
			})
	}

	handleChangeStatus = (e: any, changeStatus: string, commentId: string, originalStatus: string) => {
		e.stopPropagation();
		var self = this
		if (['Open', 'Reopen'].includes(originalStatus) && changeStatus == 'Reopen') {
			return e.preventDefault();
		}

		if (originalStatus == 'Resolved' && changeStatus == 'Resolved') {
			return e.preventDefault();
		}

		const {courseID} = this.props;
		let { limit, activeNav } = this.state;
		let reqBody = {
			status: changeStatus,
			__v: 0,
			commentId: commentId
		}

		commentService.changeStatus(reqBody)
			.then((res: any) => {
				self.handleAddCommentClose();
				self.props.clearComment();
				self.props.getCommentListCourse(courseID, activeNav, limit, 0);
				self.setState({ pageSkip: 0, isShowReplyComment: { isShow: false, commentId: '' } });
			});
	}


	isAtPresent(e: any) {
		let { value } = e.target;
		const { usersList } = this.props;
		let { searchedUser, isAtPresent, formData }: any = this.state;
		let tempMentions: any[] = [];

		//This will help to get current cursor
		//@ts-ignore
		let el = document.getElementById('comment-div').getElementsByTagName('div')[0];
		let currentCaret = this.getCaretPosition(el) - 1;


		//This will help in case of remove
		let matchSelected = value.match(/<a[^>]*>[^<]*<\/a>/gi);
		if (!_.isEmpty(matchSelected)) {
			matchSelected.forEach((sel: any) => {
				let isNamePresent = formData["mentions"] && formData["mentions"].find((mn: any) => sel && sel.toLowerCase().search(mn.text.toLowerCase()) != -1);

				if (_.isEmpty(isNamePresent)) {
					value = value.replace(sel, '');
				} else {
					tempMentions.push(isNamePresent);
				}
			})
		}

		formData["mentions"] = tempMentions;
		formData.comment = value;

		//Get current curoser value 
		let charAtIndex = el.innerText.charAt(currentCaret);
		let preCharAt: string = el.innerText.charAt(currentCaret - 1);

		//If it is '@' and his previous value is '' then in next input we have to start for searching
		//charCodeAt is used because we have to handle space i.e 32 and $nbsp i.e 160
		if (charAtIndex == "@" && [160, 32].includes(preCharAt.charCodeAt(0))) {
			isAtPresent = true;
		} else if (charAtIndex == ' ') {
			isAtPresent = false;
		}
		//if @ is presnet search for user in user list
		if (isAtPresent && charAtIndex != "@") {
			searchedUser = [];
			let tempText = el.innerText.substring(currentCaret).split(' ');
			let userName: any = tempText.slice(0, 1);
			userName = userName.length > 0 ? userName[0] : '';
			userName = userName.trim();
			usersList.forEach((user: any) => {
				if (userName && user && user.fullName && user.fullName.toLowerCase().search(userName.toLowerCase()) != -1) {
					if (searchedUser.length < 5) {
						searchedUser.push(user);
					} else {
						return false;
					}
				}
			});
		}
		this.setState({ searchedUser, isAtPresent, formData })
	}


	selectUser(userDetail: UserData, e: any) {
		const { usersList, content } = this.props;
		let { isAtPresent, formData, searchedUser } = this.state;
		if (isAtPresent) {
			//@ts-ignore
			let el = document.getElementById('comment-div').getElementsByTagName('div')[0];
			//Minus 2 so that we get caret position to be handle
			let tempCurrentCaret = this.getCaretPosition(el) - 2;
			let innerText = el.innerText;

			//When user will mark to user at previous text this will help 
			//get last cursor of his and minus 2 so that we now what we have to replace
			//For eg `Kindly keep notify to @im and mark others also` here we are intrested till "Kindly keep notify to @im" 
			//So that we can have to remove @im and replace it with user name 
			currentCaret = tempCurrentCaret > currentCaret ? currentCaret + 2 : tempCurrentCaret;

			let comment = "";

			//Conetent he is adding
			let contentId = content.content ? content.content._id : '';
			//Extract string till current position
			let tillFirst = innerText.substring(0, currentCaret);
			//now since we have extracted string and @ will be at last with some user chararacter.
			//eg. actual text = `Mark this to @inm and keep @Anuj tonic`
			//we have to deal with only `Mark this to @inm` so @ will be at last 
			let lastIndex = tillFirst.lastIndexOf('@');

			//Now we have to replace inm from above to user actual name consider using spit
			let tempText = tillFirst.substring(lastIndex + 1).split(' ');
			//get first array
			let userName: any = tempText.slice(0, 1);

			//User length to push in data
			let userNameLength = lastIndex + userDetail.fullName.length;
			let name = `@${userDetail.fullName}`;
			userName = userName.length > 0 ? userName[0] : '';
			let userId = userDetail._id;

			//Replace string `Mark this to @im and keep posting.` to `Mark this to Gaffer and keep posting` 
			//Added 1 for @
			let temp = innerText.substring(0, lastIndex);
			innerText = temp + name + innerText.substring(temp.length + userName.length + 1);


			//Push in mentions also 
			let tempBody: mentionsBody = { userId, sourceId: contentId, sourceType: 'USER', text: name, from: lastIndex, to: userNameLength };
			formData["mentions"].push(tempBody);


			formData["mentions"] && formData["mentions"].forEach((mention: any) => {
				//INFO:If string is empty we are processing it first time in that case will use innerText
				if (_.isEmpty(comment))
					comment = innerText.replace(new RegExp(`${mention.text}`, 'g'), `<a href='javascript:void(0)'>${mention.text}</a>`);
				else
					comment = comment.replace(new RegExp(`${mention.text}`, 'g'), `<a href='javascript:void(0)'>${mention.text}</a>`);

			})

			formData.comment = comment;
			isAtPresent = false;
			searchedUser = [];
		}

		this.setState({ formData, isAtPresent, searchedUser });

	}


	sanitize = () => {
		let { formData } = this.state;
		let commentText = formData["comment"];
		commentText = commentText.replace(new RegExp('<a(?=\s|>)[^>]*>.*?<\/a>', 'gi'), '');
		formData["comment"] = commentText;
		this.setState({ formData });
	};

	getCaretPosition(element: any) {
		let caretOffset = 0;
		if (element) {
			//@ts-ignore
			let range = window.getSelection().getRangeAt(0);
			let preCaretRange = range.cloneRange();
			preCaretRange.selectNodeContents(element);
			preCaretRange.setEnd(range.endContainer, range.endOffset);
			caretOffset = preCaretRange.toString().length;
		}
		return caretOffset;
	}

	preventEnter(preventE: boolean = true, commentId: string = "", e: any) {
		let { formData } = this.state;
		
		if (e.keyCode == 13) {
			if (preventE) {
				e.preventDefault();
				let commentBox:any = document.getElementById("comment-div") || null;
				if(commentBox){
					let commentNewText = commentBox.children[0].innerHTML+="\n                     \n"
					formData["comment"] = commentNewText;
					this.setState({formData});
				}
			}
			else {
				this.replyComment(commentId);
			}
		}
		//@ts-ignore
		let el = document.getElementById('comment-div').getElementsByTagName('div')[0];
		currentCaret = this.getCaretPosition(el) - 1;
	}

	replyComment(commentId: string) {
		let { formData, limit }: any = this.state;
		const { getCommentListCourse, clearComment ,courseID} = this.props;
		let self = this;
		
		var parameter = {
			"packageId": courseID,
			"comment": formData["comment"],
			"commentId": commentId
		}

		commentService.replyComment(parameter)
			.then((res: any) => {
				self.handleAddCommentClose();
				clearComment();
				getCommentListCourse(courseID, 'OPEN', limit, 0);
				this.setState({ pageSkip: 0 })
			})

	}

	openAddCommentDialogue(e: any) {
		this.resetForm();
		this.setState({ isAddCommentDialogOpen: true });
	}


	handleCommentEdit(commentDetail: any, e: any) {
		let { formData }: any = this.state;
		if (!_.isEmpty(commentDetail)) {
			formData["comment"] = commentDetail.comment;
			formData["contentId"] = commentDetail.contentId;
			formData["packageId"] = commentDetail.contentId;
			formData["userId"] = commentDetail.userId;
			formData["readBy"] = commentDetail.readBy;
			formData["mentions"] = commentDetail.mentions;
			formData["commentStatus"] = commentDetail.commentStatus;
			formData["updatedAt"] = commentDetail.updatedAt;
			formData["createdAt"] = commentDetail.createdAt;
			formData["_id"] = commentDetail._id;

			this.setState({ isAddCommentDialogOpen: true, isEdit: true });
		}

	}

	handleCloseCommentBox() {
		this.resetForm();
		this.props.dialogCloseHandler();
	}
	
	listenToScroll(e: any) {
		let { isPageAvailabe, pageSkip, activeNav, limit } = this.state;
		const { content, getCommentListCourse, comments } = this.props;
		if (limit * (1 + pageSkip) == comments.length && this.el.scrollTop < 20) {
			let contentId = _.get(content.content, '_id', '');
			pageSkip = pageSkip + 1;
			this.el.scrollTop = this.el.scrollHeight / 3;
			this.props.getCommentListCourse(contentId, activeNav, limit, pageSkip);
			this.setState({ pageSkip, isPageAvailabe: true });
		} else {
			this.setState({ isPageAvailabe: true });
		}
	}



	render() {
		const {
			classes,
			isDialogOpen,
			dialogCloseHandler,
			comments,
			userDetail
		} = this.props;
		//Set default Value
		const { activeNav, isAddCommentDialogOpen, isShowReplyComment, searchedUser, formData, moreMenuAnchor, openMenu, isEdit } = this.state;


		const otherDialogProps = {
			fullWidth: true,
			maxWidth: 'sm',
			scroll: 'body',
		}

		const addCommentDialogTitle = (
			<Typography variant="h5" className={classes.commentTitle}> {isEdit ? 'Edit Comment' : 'Add Comment'}</Typography>
		)

		const commentDialogTitle = (<>
			<Grid container justify="space-between" alignItems="center">
				<Grid item xs>
					<Typography variant="h5" align="left" className={classes.commentTitle}>Comments</Typography>
				</Grid>
				<Grid item xs='auto'>
					<Button
						variant="contained"
						color="primary"
						className={classes.addCommentBtn}
						onClick={this.openAddCommentDialogue}
					>
						Add Comment
      </Button>
				</Grid>
				<Grid item xs="auto" className={classes.dialogCloseContainer}>
					<MyPATIconButton buttonVariant="flat" onClick={this.handleCloseCommentBox}>
						<CloseIcon />
					</MyPATIconButton>
				</Grid>
			</Grid>
		</>
		)

		return (
			<>
				<MyPATDialog
					customDialogTitle={commentDialogTitle}
					dialogOpen={isDialogOpen}
					otherDialogProps={otherDialogProps}
					onDialogClose={this.handleCloseCommentBox}
				>
					<ul className={classes.navigation}>
						<li className={_.isEqual(activeNav, 'open') ? "active" : ""}>
							<a href="javascript:void(0)" onClick={this.handleNavigationClick.bind(this, 'open')}>
								Open {' '}|
            </a>
						</li>
						<li className={_.isEqual(activeNav, 'close') ? "active" : ""}>
							<a href="javascript:void(0)" onClick={this.handleNavigationClick.bind(this, 'close')}>
								Close {' '}|
            </a>
						</li>
						<li className={_.isEqual(activeNav, 'all') ? "active" : ""}>
							<a href="javascript:void(0)" onClick={this.handleNavigationClick.bind(this, 'all')}>
								All
            </a>
						</li>

					</ul> 
					<div className={classes.containerHeight} onScroll={(e: any) => this.listenToScroll(e)} ref={el => { this.el = el; }}>
						{
							_.isEmpty(comments) ?
								<Typography variant='subtitle1' color='textSecondary' align='center'>
									<strong >No Comment</strong>
								</Typography>
								:
								_.map(comments, (comment: any) => (
									<MyPATExpansionPanel
										key={`comment-${comment._id}`}
										defaultExpanded={false}
										hasExpandIcon={false}
										panelProps={{ className: `${classes.mb1x5x}` }}
										customCollapseTitle={
											<Grid container justify="space-between" spacing={8} className={`${classes.commentGridBox} ${classes.paddingZero}`}>
												<Grid item xs='auto' className={classes.profileWrapper}>
													<Avatar alt={`Profile ${comment.firstName}`} src={_.isEmpty(comment.userProfileImage) ? "/assets/img/profile-default.png" : comment.userProfileImage} className={classes.avatar} />
												</Grid>

												<Grid item xs>
													<Grid container>
														<Grid item xs>
															<Typography variant="h6" inline>
																<strong className={classes.textCapitalize}>{comment.firstName} {comment.lastName}</strong>
															</Typography>
														</Grid>
														<Grid item xs style={{ position: 'relative' }}>
															<Typography variant="caption" color='textSecondary' className={classes.commentTime} inline>
																{`${dateService.getTimeAgo(comment.createdAt)} Ago`}
															</Typography>

															{
																_.isEqual(userDetail.authenticatedUser._id, comment.userId)
																&& <>
																	<MyPATIconButton
																		buttonVariant="flat"
																		aria-haspopup="true"
																		onClick={(e: any) => this.handleMoreMenuOpen(e, `menu-${comment._id}`)}
																		className={classes.moreMenuButton}
																	>
																		<MoreIcon />
																	</MyPATIconButton>


																	<Menu
																		id={`menu-${comment._id}`}
																		open={_.isEqual(`menu-${comment._id}`, openMenu) ? true : false}
																		anchorEl={moreMenuAnchor}
																		onClose={(e: any) => this.handleMoreMenuClose(e)}
																		className={classes.moreMenu}
																	>
																		{
																			_.isEqual(comment.commentStatus, 'Open') &&
																			<MenuItem>
																				<a href="javascript:void(0)" onClick={this.handleCommentEdit.bind(this, comment)} > Edit</a>
																			</MenuItem>
																		}
																		<MenuItem onClick={(e) => this.handleDeleteCommentMenuClick(e, comment._id)}>
																			<a href="javascript:void(0)">Delete</a>
																		</MenuItem>
																	</Menu>
																</>
															}
														</Grid>
													</Grid>
													<ContentEditable
														className={`${classes.nonEditableBox} ${classes.contentEditable}`}
														tagName="div"
														html={comment.comment}
														disabled={true}
													/>
													<ul className={classes.navigation}>
													{!_.isEqual(comment.commentStatus, 'Resolved') &&
															<li className={['Open', 'Reopen'].includes(_.get(comment, 'commentStatus', '')) ? "active" : ""}>
																<a href="javascript:void(0)" onClick={(e) => this.handleReplyCommentToggle(e, comment._id)}>
																	Reply{' '}.
                        				</a>
															</li>
														}
														<li className={['Open', 'Reopen'].includes(_.get(comment, 'commentStatus', '')) ? "active" : ""}>
															<a href="javascript:void(0)" onClick={(e) => this.handleChangeStatus(e, 'Resolved', comment._id, comment.commentStatus)}>
																Resolve {' '}.
                        			</a>
														</li>
														<li className={_.isEqual(comment.commentStatus, 'Resolved') ? "active" : ""}>
															<a href="javascript:void(0)" onClick={(e) => this.handleChangeStatus(e, 'Reopen', comment._id, comment.commentStatus)}>
																Re-open
                        			</a>
														</li>

													</ul>

												</Grid>
											</Grid>
										}
									>
										{_.map(comment.replies, reply => (
											<Card
												key={`${reply._id}-of-${comment._id}`} className={classes.mb1x}>
												<CardContent className={classes.cardContentRoot}>
													<Grid className={classes.paddingContent} container spacing={8}>
														<Grid item xs='auto' className={classes.profileWrapper}>
															<Avatar alt={`Profile ${reply.userId.firstName}`} src={_.isEmpty(reply.userId.profileImage) ? "/assets/img/profile-default.png" : reply.userId.profileImage} className={classes.replyAvatar} />
														</Grid>

														<Grid item xs>
															<div style={{ position: 'relative' }}>
																<Typography variant="subtitle1" inline className={classes.bold}>
																	<strong className={classes.textCapitalize}>{reply.userId.firstName} {reply.userId.lastName}</strong>
																</Typography>
																{
																	_.get(reply, 'comment', '') == "Marked as Resolved" &&
																	<Typography inline variant="subtitle2" className={classes.markedResolved}>Marked as resolved</Typography>
																}
																{
																	_.get(reply, 'comment', '') == "Marked as Reopen" &&
																	<Typography inline variant="subtitle2" className={classes.markedResolved}>Marked as reopen</Typography>
																}
																<div>
																	{
																		_.isEqual(userDetail.authenticatedUser._id, _.get(reply.userId, '_id', ''))
																		&& <>
																			<MyPATIconButton
																				buttonVariant="flat"
																				aria-haspopup="true"
																				onClick={(e: any) => this.handleMoreMenuOpen(e, `menu-${reply._id}`)}
																				className={classes.moreMenuButton}
																			>
																				<MoreIcon />
																			</MyPATIconButton>
																			<Menu
																				id={`menu-${reply._id}`}
																				open={_.isEqual(`menu-${reply._id}`, openMenu) ? true : false}
																				anchorEl={moreMenuAnchor}
																				onClose={(e: any) => this.handleMoreMenuClose(e)}
																				className={classes.moreMenu}
																			>
																				{
																					_.isEqual(comment.commentStatus, 'Open') &&
																					<MenuItem>
																						<a href="javascript:void(0)" onClick={this.handleCommentEdit.bind(this, reply)} > Edit</a>
																					</MenuItem>
																				}
																				<MenuItem onClick={(e) => this.handleDeleteCommentMenuClick(e, reply._id)}>
																					<a href="javascript:void(0)">Delete</a>
																				</MenuItem>
																			</Menu>
																		</>
																	}
																</div>
															</div>
															{
																!["Marked as Resolved", "Marked as Reopen"].includes(reply.comment) && (
																	<ContentEditable
																		className={`${classes.nonEditableBox} ${classes.contentEditable}`}
																		tagName="div"
																		html={reply.comment}
																		disabled={true}
																	/>
																)
															}
															<Typography variant="caption" color='textSecondary'>
																{`${dateService.getTimeAgo(reply.createdAt)} Ago`}
															</Typography>
														</Grid>
													</Grid>
												</CardContent>
											</Card>
										))}
										{isShowReplyComment.isShow && isShowReplyComment.commentId == comment._id &&
											<Card
												className={classes.mb1x}>
												<CardContent className={classes.cardContentRoot}>
													<Grid container alignItems="center" spacing={8}>
														<Grid item xs='auto' className={classes.profileWrapper}>
															<Avatar alt={`Profile ${comment.firstName}`} src={_.isEmpty(comment.userProfileImage) ? "/assets/img/profile-default.png" : comment.userProfileImage} className={classes.replyAvatar} />
														</Grid>

														<Grid item xs>
															{!isAddCommentDialogOpen &&
																<div id="comment-div" style={{ position: 'relative' }}>
																	{
																		!formData.comment && (
																			<Typography variant="subtitle1" className={classes.replyPlaceHolder} inline>
																				Reply to this thread
																			</Typography>
																		)
																	}
																	<ContentEditable
																		className={`${classes.editableBoxReply} ${classes.contentEditable}`}
																		tagName="div"
																		html={formData.comment}
																		onChange={this.isAtPresent}
																		onBlur={this.sanitize}
																		onKeyDown={this.preventEnter.bind(this, false, comment._id)} />
																</div>
															} {!_.isEmpty(searchedUser) && !isAddCommentDialogOpen &&
																<List className={classes.suggesedtedUser}>
																	{_.map(searchedUser, (user: any) => (
																		<ListItem divider={true} key={`user_${user._id}`} onClick={this.selectUser.bind(this, user)}>
																			<ListItemAvatar>
																				<Avatar alt={`Profile ${user.firstName}`} src={_.isEmpty(user.profileImage) ? "/assets/img/profile-default.png" : user.profileImage} className={classes.miniAvater} />
																			</ListItemAvatar>
																			<ListItemText primary={user.fullName} />
																		</ListItem>

																	))}
																</List>
															}
														</Grid>
													</Grid>
												</CardContent>
											</Card>
										}
									</MyPATExpansionPanel>
								))}
					</div>
				</MyPATDialog>

				{isAddCommentDialogOpen &&
					<MyPATDialog
						customDialogTitle={addCommentDialogTitle}
						dialogOpen={isAddCommentDialogOpen}
						customDialogActions={
							isEdit ?
								<Button
									variant="contained" color="primary"
									onClick={this.handleEditCommentDialog}
								> Edit Comment
              </Button>
								:
								<Button
									variant="contained" color="primary"
									onClick={this.handleAddCommentDialogSave}
								> Add Comment
              </Button>
						}
						otherDialogProps={otherDialogProps}
						onDialogClose={this.handleAddCommentClose}
					>
						<div style={{ position: 'relative' }}>
							<Typography variant="h6" inline>
								<strong className={classes.textCapitalize}>Comment</strong>
							</Typography>

							{
								isAddCommentDialogOpen &&
								<div id="comment-div">
									<ContentEditable
										className={`${classes.editableBox} ${classes.contentEditable}`}
										tagName="div"
										html={formData.comment}
										onChange={this.isAtPresent}
										onBlur={this.sanitize}
										// onKeyDown={this.preventEnter.bind(this, false, '')}
										
									/>
								</div>
							}
							{
								!_.isEmpty(searchedUser) &&
								<List className={`${classes.suggesedtedUser} ${classes.top35}`}>
									{
										_.map(searchedUser, (user: any) => (
											<ListItem
												divider={true}
												key={`user_${user._id}`}
												onClick={this.selectUser.bind(this, user)}
											>
												<ListItemAvatar>
													<Avatar alt={`Profile ${user.firstName}`} src={_.isEmpty(user.profileImage) ? "/assets/img/profile-default.png" : user.profileImage}
														className={classes.miniAvater}
													/>
												</ListItemAvatar>
												<ListItemText primary={user.fullName} />
											</ListItem>
										))
									}
								</List>
							}
						</div>
					</MyPATDialog>
				}
			</>
		)
	}
}


const mapStateToProps = (state: any) => ({
	comments: _.get(state, 'mylibraryData.comment.list', []),
	usersList: _.get(state, 'mylibraryData.users.list', []),
	userDetail: _.get(state, "loginData.userData", {}),
});



const mapDispatchToProps = (dispatch: any) => bindActionCreators({
	getCommentListCourse,
	clearComment,
}, dispatch);



// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CourseCommentDialog));